@if (label()) {
  <label (click)="cycle()">
    {{ label() }}
  </label>
}

@let selected = selectedOption();

@for (option of options(); track $index) {
  @let isActive = selected && selected[keyName()] === option[keyName()];
  @let dataAttrIndex = optionDataAttr();

  <button
    (click)="onChangeValue(option)"
    tabindex="1"
    type="button"
    [disabled]="isDisabled() || option.disabled"
    [attr.data-active]="isActive"
    [class.active]="isActive"
    [class.has-icon]="option[optionIcon()]"
    [attr.data-test]="dataAttrIndex ? option[dataAttrIndex] : undefined"
  >
    @if (option[optionIcon()]; as iconName) {
      <svg
        [attr.width]="iconSize()"
        [attr.height]="iconSize()"
        [attr.viewBox]="iconViewBox()"
      >
        <use [attr.xlink:href]="iconName"></use>
      </svg>
    }

    @if (option[optionLabel()]; as label) {
      <span>
        {{ label }}
      </span>
    }
  </button>
}
